import { styled } from "@mui/material/styles"

export const AddWishItemIconContainer = styled("div")(({ theme }) => ({
  width: "24px",
  height: "24px",

  "& svg": {
    width: "100%",
    height: "100%",
    stroke: "#FFFFFF !important",
    backgroundColor: `${theme.palette.primary["6"]} !important`,
    borderRadius: "50%"
  }
}))
